import { FC, ReactNode } from 'react'
import { Body1, makeStyles } from '@perk-ui/core'
import clsx from 'clsx'

export interface DataPairProps {
  label: string
  value: ReactNode
  customClass?: string
}

const useStyles = makeStyles(() => ({
  label: {
    // Just a smidge lighter than 'bold'
    fontWeight: 500,
  },
}))

const DataPair: FC<DataPairProps> = ({ label, value, customClass }) => {
  const classes = useStyles()
  return (
    <Body1 gutterBottom className={customClass}>
      <span className={clsx(classes.label)}>{label}:</span> {value}
    </Body1>
  )
}

export default DataPair
